import React from "react";
import { Box, Typography, Flex, Checkbox } from "flux";
import { ASPECT_RATIO_ORDER } from "../../constants/aspect-ratios";

interface AspectRatioCheckboxesProps {
  value?: string[];
  onChange: (aspectRatios: string[]) => void;
  dataDogIdentifier?: string;
}

const AspectRatioCheckboxes: React.FC<AspectRatioCheckboxesProps> = ({
  value = [],
  onChange,
  dataDogIdentifier = "aspect ratio checkbox"
}) => {
  const handleCheckboxChange = (aspectRatio: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedAspectRatios = event.target.checked
      ? [...value, aspectRatio]
      : value.filter((ar) => ar !== aspectRatio);

    onChange(updatedAspectRatios);
  };

  return (
    <Box>
      <Typography variant="subtitle1">Aspect Ratios</Typography>
      <Flex flexDirection="row" alignItems="center" gap={1}>
        {ASPECT_RATIO_ORDER.map((aspectRatio) => (
          <Box key={aspectRatio} sx={{ display: "flex", alignItems: "center" }}>
            <Checkbox
              checked={value.includes(aspectRatio)}
              onChange={handleCheckboxChange(aspectRatio)}
              dataDogIdentifier={dataDogIdentifier}
            />
            <Typography>{aspectRatio.toUpperCase()}</Typography>
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default AspectRatioCheckboxes;
